(function () {
  "use strict";

  let booted = false;

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function moneyFormat() {
    const root = qs(document, "[data-sunnier-pergola-options]");
    return (root && root.dataset.moneyFormat) || "£{{amount}}";
  }

  function formatMoney(cents) {
    const format = moneyFormat();
    if (window.FoxTheme && FoxTheme.Currency && typeof FoxTheme.Currency.formatMoney === "function") {
      return FoxTheme.Currency.formatMoney(cents, format);
    }
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, format);
    }
    const amount = (Number(cents) / 100).toFixed(2);
    return format.indexOf("{{amount}}") >= 0
      ? format.replace("{{amount}}", amount)
      : "£" + amount;
  }

  function getLiveTotalCents() {
    if (window.SunnierPergolaConfig && typeof window.SunnierPergolaConfig.getTotalCents === "function") {
      return Number(window.SunnierPergolaConfig.getTotalCents()) || 0;
    }
    return 0;
  }

  function getConfigSnapshot(actionsRoot) {
    if (window.SunnierPergolaConfig && typeof window.SunnierPergolaConfig.getConfigSnapshot === "function") {
      return window.SunnierPergolaConfig.getConfigSnapshot();
    }
    return {
      product: (actionsRoot && actionsRoot.dataset.productTitle) || "",
      handle: (actionsRoot && actionsRoot.dataset.productHandle) || "",
      summary: "",
      totalCents: getLiveTotalCents(),
      url: location.href,
    };
  }

  function renderFinance(actionsRoot) {
    const months = Number(actionsRoot.dataset.financeMonths || 12) || 12;
    const total = getLiveTotalCents();
    const monthlyEl = qs(actionsRoot, "[data-sunnier-finance-monthly]");
    const line = qs(actionsRoot, "[data-sunnier-finance-line]");
    if (!monthlyEl || !line || total <= 0) return;
    const monthlyCents = Math.ceil(total / months / 100) * 100;
    monthlyEl.textContent = formatMoney(monthlyCents);
    line.hidden = false;

    qsa(document, "[data-sunnier-sticky-finance]").forEach((el) => {
      el.textContent = "From " + formatMoney(monthlyCents) + "/mo";
      el.hidden = false;
    });
  }

  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    const first = qs(modal, "input, textarea, button");
    if (first) first.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  function buildBodyMessage(actionsRoot, note) {
    const snap = getConfigSnapshot(actionsRoot);
    const lines = [
      "CALLBACK REQUEST — Saved pergola design",
      "",
      "Name / contact details are in the form fields above.",
      "",
      "Product: " + (snap.product || ""),
      "Handle: " + (snap.handle || ""),
      "Configuration: " + (snap.summary || ""),
      "Size: " + (snap.size || ""),
      "Colour: " + (snap.colour || ""),
      "Mount: " + (snap.mount || ""),
      "Height: " + (snap.height || ""),
      "Assembly: " + (snap.assembly || ""),
      "Extras: " + (snap.extras || ""),
      "Estimated total: " + (snap.totalCents ? formatMoney(snap.totalCents) : "n/a"),
      "Page: " + (snap.url || location.href),
    ];
    if (note) {
      lines.push("", "Customer note:", note);
    }
    return lines.join("\n");
  }

  function setStatus(status, message, isError) {
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || "";
    status.dataset.error = isError ? "true" : "false";
  }

  function showSuccess(modal) {
    if (!modal) return;
    const panel = qs(modal, "[data-sunnier-save-panel]");
    const success = qs(modal, "[data-sunnier-save-success]");
    const formView = qs(modal, "[data-sunnier-save-form-view]");
    if (panel) panel.classList.add("is-success");
    if (success) success.hidden = false;
    if (formView) formView.hidden = true;
    openModal(modal);
  }

  function showFormView(modal) {
    if (!modal) return;
    const panel = qs(modal, "[data-sunnier-save-panel]");
    const success = qs(modal, "[data-sunnier-save-success]");
    const formView = qs(modal, "[data-sunnier-save-form-view]");
    if (panel) panel.classList.remove("is-success");
    if (success) success.hidden = true;
    if (formView) formView.hidden = false;
  }

  function initSaveDesign(actionsRoot) {
    const modal = qs(document, "[data-sunnier-save-modal]");
    if (!modal) return;

    // Avoid nested <form> issues inside product / sticky ATC forms
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const form = qs(modal, "form");
    const preview = qs(modal, "[data-sunnier-save-config-preview]");
    const bodyInput = qs(modal, "[data-sunnier-save-body]");
    const noteInput = qs(modal, "[data-sunnier-save-note]");
    const status = qs(modal, "[data-sunnier-save-status]");
    const submitBtn = qs(modal, "[data-sunnier-save-submit]");

    function refresh() {
      renderFinance(actionsRoot);
    }

    refresh();
    document.addEventListener("sunnier:config-ready", refresh);
    document.addEventListener("variant:changed", refresh);
    document.addEventListener("change", (e) => {
      if (e.target && e.target.closest("[data-sunnier-pergola-options], [data-sunnier-screens]")) {
        refresh();
      }
    });

    function handleOpen(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      const snap = getConfigSnapshot(actionsRoot);
      const lines = [
        snap.product || actionsRoot.dataset.productTitle || "Pergola",
        snap.summary || "",
        snap.totalCents ? "Estimated total: " + formatMoney(snap.totalCents) : "",
      ].filter(Boolean);
      if (preview) preview.textContent = lines.join(" · ") || "Your current configuration";
      if (bodyInput) bodyInput.value = buildBodyMessage(actionsRoot, "");
      setStatus(status, "", false);
      showFormView(modal);
      openModal(modal);
    }

    // Event delegation so sticky ATC buttons work even if added later
    if (!document.__sunnierSaveDesignBound) {
      document.__sunnierSaveDesignBound = true;
      document.addEventListener("click", (event) => {
        const btn = event.target.closest("[data-sunnier-save-design]");
        if (!btn) return;
        const root = qs(document, "[data-sunnier-buy-actions]") || actionsRoot;
        handleOpen.call(root, event);
      });
    }

    qsa(modal, "[data-sunnier-modal-close]").forEach((el) => {
      el.addEventListener("click", () => closeModal(modal));
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !modal.hidden) closeModal(modal);
    });

    if (form && !form.__sunnierBound) {
      form.__sunnierBound = true;

      // Native submit only. Fetch / form.submit() skips Shopify hCaptcha and
      // lands on the /challenge "failed captcha" page.
      form.addEventListener("submit", (event) => {
        const note = noteInput ? noteInput.value.trim() : "";
        if (bodyInput) bodyInput.value = buildBodyMessage(actionsRoot, note);

        if (!bodyInput || !bodyInput.value.trim()) {
          event.preventDefault();
          setStatus(status, "Could not capture your configuration. Please refresh and try again.", true);
          return;
        }

        if (submitBtn) submitBtn.textContent = "Sending…";
        setStatus(status, "Sending your design…", false);
      });
    }

    const posted =
      location.search.indexOf("contact_posted=true") >= 0 ||
      location.search.indexOf("design_saved=1") >= 0;
    if (posted) {
      showSuccess(modal);
    } else if (qs(modal, ".sunnier-modal__status[data-error='true']")) {
      showFormView(modal);
      openModal(modal);
    }
  }

  function boot() {
    const actionsRoot = qs(document, "[data-sunnier-buy-actions]");
    if (!actionsRoot) return;
    if (booted && qs(document, "[data-sunnier-save-modal]")) {
      renderFinance(actionsRoot);
      return;
    }
    booted = true;
    initSaveDesign(actionsRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
